export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8155.93a87705.jpg";